// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_Bhw","left":"styles_left__r8cJ6","right":"styles_right__15btM","alert":"styles_alert__2bj87"};